export type InstallEnvironment =
  | 'standalone'
  | 'chromium-prompt'
  | 'ios-safari'
  | 'ios-embedded'
  | 'unavailable'

export type InstallEnvironmentInput = {
  displayModeStandalone: boolean
  hasInstallPrompt: boolean
  maxTouchPoints: number
  navigatorStandalone: boolean
  userAgent: string
  vendor: string
}

export function installOrigin(value: string): string {
  return new URL(value).origin
}

export function isLocalPreviewOrigin(value: string): boolean {
  const hostname = new URL(value).hostname.toLocaleLowerCase('en-US')
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]'
}

export function isSkipWaitingMessage(value: unknown): boolean {
  if (value === 'SKIP_WAITING') return true
  if (!value || typeof value !== 'object') return false
  return (value as { type?: unknown }).type === 'SKIP_WAITING'
}

export function detectInstallEnvironment(input: InstallEnvironmentInput): InstallEnvironment {
  if (input.displayModeStandalone || input.navigatorStandalone) return 'standalone'
  if (input.hasInstallPrompt) return 'chromium-prompt'

  const isIos = /iphone|ipad|ipod/iu.test(input.userAgent) || (
    /macintosh/iu.test(input.userAgent) && input.maxTouchPoints > 1
  )
  if (!isIos) return 'unavailable'

  const isSafari = /safari/iu.test(input.userAgent) && /version\//iu.test(input.userAgent) &&
    !/(?:crios|fxios|edgios|opios|instagram|fban|fbav|line\/|linkedinapp)/iu.test(input.userAgent) &&
    /apple/iu.test(input.vendor)
  return isSafari ? 'ios-safari' : 'ios-embedded'
}
